/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import EntityLabel from '@ion/core/src/entities/EntityLabel';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {IconRadioLabel} from '../radio/IconRadioLabel';
import RadioButton from '../radio/RadioButton';
import {AutocompleteSearchResult} from '../search/AutocompleteSearchResult';

interface GroupSelectionProps {
  item: any;
  searchValue: string;
  onViewSubaccounts: Function;
}

/**
 * Component to display Global Account Item
 * ```typescript
 *  import GroupSelection from '@ion/dls/src/components/groupchooser/GroupSelection';
 * 
 *  <GroupSelection item={group}
 *   searchValue={searchValue}
 *   onViewSubaccounts={onViewSubaccounts}/>
 * ```
 */
const GroupSelection = ({
  item,
  searchValue,
  onViewSubaccounts
}: GroupSelectionProps) => {
  const onIconClick = useCallback(function(e) {
    e.stopPropagation();
    e.preventDefault();
    onViewSubaccounts(item, true);
  }, [item]);
  return (
    <RadioButton value={item.href}
      label={
        <IconRadioLabel label={
          <AutocompleteSearchResult option={{name: EntityLabel.get(item)}}
            searchValue={searchValue}
            highlightColor={dlsColor('lightBlue')} />
        } onIconClick={item.subAccounts ? onIconClick : undefined} />} />
  );
};

export default GroupSelection;
